import React, { FC } from 'react';
import { MediumBar, SmallBar, TinyBar } from '@src/components/Skeletons/Forms';
import './styles.scss';

export const OpeningSkeleton: FC = () => {
  return (
    <div className="opening-skeleton pulse-fade">
      <div className="opening-skeleton__title-container">
        <MediumBar />
        <div className="opening-skeleton__title" />
        <div className="opening-skeleton__subtitle-container">
          <TinyBar className="opening-skeleton__subtitle" />
          <SmallBar className="opening-skeleton__subtitle" />
        </div>
      </div>
      <div className="opening-skeleton__status-container">
        <TinyBar className="opening-skeleton__status" />
        <TinyBar className="opening-skeleton__status" />
      </div>
    </div>
  );
};
